/* (c) Copyright Frontify Ltd., all rights reserved. */

export const TEXT_STYLE_PLUGIN = 'text-style-plugin';
